const sections = document.querySelectorAll(".s-selected-filters")
const sectionsToShow = document.querySelectorAll(".s-estaters-filter-switch, .s-category-nav, .s-main-filter")

sections.forEach((section) => {
    const template = section.querySelector<HTMLTemplateElement>("#selected-filter-item")
    const list = section.querySelector<HTMLElement>(".s-selected-filters__list")
    const opener = section.querySelector(".s-selected-filters__opener")

    sectionsToShow.forEach((section) => {
        if (!sections[0].classList.contains('d-none')) {
            section.classList.add("d-none")
        }
    })

    const selectedItems = document.querySelectorAll<HTMLInputElement>(".s-main-filter .checkbox__input:checked")

    const getListCount = () => list?.querySelectorAll(".i-selected-filter").length ?? 0

    const addItem = (title: string, id: string) => {
        if (!template || !list) return

        const itemOriginal = template.content.querySelector<HTMLElement>(".i-selected-filter")
        if (!itemOriginal) return

        const itemNew = itemOriginal.cloneNode(true) as HTMLElement

        itemNew.addEventListener("click", () => {
            const input = document.querySelector<HTMLInputElement>(`#${id}`)
            if (!input) return

            input.checked = false
            input.dispatchEvent(new Event("change"))
            itemNew.remove()

            if (getListCount() === 0) {
                // nothing in list
            }
        })

        itemNew.dataset.filterId = id

        const itemTitle = itemNew?.querySelector(".i-selected-filter__title")

        if (itemTitle) itemTitle.innerHTML = title

        list.insertAdjacentElement("beforeend", itemNew)
    }

    selectedItems.forEach((checkbox) => {
        const title = checkbox.dataset.title
        const id = checkbox.id

        if (!title || !id) return

        addItem(title, id)
    })

    opener?.addEventListener("click", () => {
        section.classList.add("--hidden")
        window.scrollTo({top: 0, behavior: "smooth"});
        sectionsToShow.forEach((section) => {
            section.classList.remove("d-none")
            section.style.display = ''
        })
    })
})
